import {showGlobalErrorMessage} from '../modules/errors.ts';
import {addDelegatedEventListener} from '../utils/dom.ts';

export function initUserThemePreview() {
  const form = document.querySelector<HTMLFormElement>('#user-theme-form');
  const themeLink = document.querySelector<HTMLLinkElement>('#gitea-theme-css');
  if (!form || !themeLink) return;

  const originalURI = themeLink.getAttribute('href')!;
  let previewID = 0;
  addDelegatedEventListener(form, 'click', '.menu > .item', (item) => {
    const themeURI = item.getAttribute('data-theme-uri');
    if (!themeURI || themeLink.href === new URL(themeURI, document.baseURI).href) return;

    const currentPreviewID = ++previewID;
    themeLink.addEventListener('error', () => {
      if (previewID !== currentPreviewID) return;
      themeLink.setAttribute('href', originalURI);
      showGlobalErrorMessage(form.getAttribute('data-theme-preview-error')!);
    }, {once: true});
    themeLink.setAttribute('href', themeURI);
  });
}
